import(/* webpackMode: "eager" */ "/vercel/path1/app/error.tsx");
